import React from 'react';
import { connect } from 'react-redux';
import { PropTypes as T } from 'prop-types';
import { withRouter } from 'react-router-dom';
import _set from 'lodash.set';
import _cloneDeep from 'lodash.clonedeep';
import Ajv from 'ajv';
import ajvKeywords from 'ajv-keywords';

import { environment } from '#config';

import { validateAndUpdatePassword } from '#actions';
import { get } from '#utils/utils';
import schemaDef from '#root/schemas/new-password';
import { FormInput, FormError } from '#components/form-elements/';
import { showAlert } from '#components/system-alerts';
import { showGlobalLoading, hideGlobalLoading } from '#components/global-loading';
import LanguageContext from '#root/languageContext';
import Translate from '#components/Translate';

const ajv = new Ajv({ $data: true, allErrors: true, errorDataPath: 'property' });
ajvKeywords(ajv);
const validator = ajv.compile(schemaDef);

const getClassIfError = (errors, prop) => {
  if (!errors) return '';
  let err = errors.find(o => o.dataPath === `.${prop}`);
  return err ? 'form__control--danger' : '';
};

class NewPassword extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      data: {
        oldPassword: undefined,
        password: undefined,
        passwordConfirm: undefined
      },
      errors: null
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.password.fetching && !nextProps.password.fetching) {
      hideGlobalLoading();
      if (nextProps.password.error) {
        showAlert(
          'danger',
          <p>
            <Translate
              stringId="newPasswordErrorMessage"
              params={{ message: nextProps.password.error.error_message }}
            />
          </p>,
          true,
          4500,
        );
      } else {
        showAlert('success', <p><Translate stringId="newPasswordSuccessMessage" /></p>, true, 2000);
        setTimeout(() => this.props.history.push('/account'), 2000);
      }
    }
  }

  onSubmit (e) {
    e.preventDefault();
    const { data } = this.state;
    validator(data);
    const errors = _cloneDeep(validator.errors);

    // Selectively apply validation based on whether
    // we are verifying an existing password, as opposed
    // to resetting a password.
    const { verifyOldPassword } = this.props;
    if (verifyOldPassword && !data.oldPassword) {
      errors.push({
        dataPath: '.oldPassword',
        keyword: 'required'
      });
    }

    this.setState({ errors });
    if (errors !== null) { return; }

    showGlobalLoading();
    let payload = {};
    if (verifyOldPassword) {
      payload.username = get(this.props, 'user.data.username');
      payload.password = data.oldPassword;
    } else {
      payload.username = get(this.props, 'match.params.username');
      payload.token = get(this.props, 'match.params.token');
    }
    payload['new_password'] = data.password;
    this.props._validateAndUpdatePassword(payload);
  }

  onFieldChange (field, e) {
    let data = _cloneDeep(this.state.data);
    let val = e.target ? e.target.value : e;
    _set(data, field, val === '' || val === null ? undefined : val);
    this.setState({data});
  }

  renderPasswordField (label, id) {
    return (
      <FormInput
        label={label}
        type='password'
        name={`newpassword-${id}`}
        id={`newpassword-${id}`}
        classInput={getClassIfError(this.state.errors, id)}
        value={this.state.data[id]}
        onChange={this.onFieldChange.bind(this, id)}
      >
        <FormError
          errors={this.state.errors}
          property={id}
        />
      </FormInput>
    );
  }

  render () {
    const { verifyOldPassword } = this.props;
    const { strings } = this.context;
    return (
      <form className='form form--centered' onSubmit={this.onSubmit}>
        {verifyOldPassword && this.renderPasswordField(strings.newPasswordVerifyInputLabel, 'oldPassword')}
        {this.renderPasswordField(strings.newPasswordField, 'password')}
        {this.renderPasswordField(strings.newPasswordConfirm, 'passwordConfirm')}
        <button className='mfa-tick' type='button' onClick={this.onSubmit}>
          <span>
            <Translate stringId='newPasswordSubmit'/>
          </span>
        </button>
      </form>
    );
  }
}

NewPassword.contextType = LanguageContext;
if (environment !== 'production') {
  NewPassword.propTypes = {
    user: T.object,
    password: T.object,
    history: T.object,
    match: T.object,
    verifyOldPassword: T.bool,
    _validateAndUpdatePassword: T.func
  };
}

const selector = (state) => ({
  user: state.user,
  password: state.password
});

const dispatcher = (dispatch) => ({
  _validateAndUpdatePassword: (payload) => dispatch(validateAndUpdatePassword(payload))
});

export default withRouter(connect(selector, dispatcher)(NewPassword));
